export default "__VITE_ASSET__6c3e2b15__"